import React from 'react';
import Diamond from '@uber/base-icons/diamond-filled';
import { useStyletron } from 'baseui';
import { Badge, COLOR, SHAPE } from 'baseui/badge';
import { useAtomValue, useSetAtom } from 'jotai';
import { annotationIdToLabelMapAtom, annotationMetadataAtom } from '../../atoms/annotation-atoms';
import { frameImageUrlsAtom } from '../../atoms/frame-image-urls-atom';
import { dispatchAtom } from '../../atoms/label-store-dispatch/dispatch';
import { EVENTS } from '../../atoms/label-store-dispatch/events';
import { currentFrameAtom } from '../../atoms/video-playback-atoms';
export const VideoGrid = () => {
  const [css, theme] = useStyletron();
  const frameImageUrls = useAtomValue(frameImageUrlsAtom);
  const annotationMetadata = useAtomValue(annotationMetadataAtom);
  const annotationIdToLabelMap = useAtomValue(annotationIdToLabelMapAtom);
  const currentFrame = useAtomValue(currentFrameAtom);
  const dispatch = useSetAtom(dispatchAtom);
  const handleFrameClick = (frameIndex: number) => {
    dispatch({
      type: EVENTS.SET_CURRENT_FRAME,
      frameId: frameIndex
    });
  };
  const getAnnotationsInFrame = (frameIndex: number) => {
    const annotationsInFrame = [...annotationMetadata.entries()].filter(([, m]) => m.spans.some(span => span.start <= frameIndex && frameIndex <= span.end));
    if (annotationsInFrame.length === 0) {
      return null;
    }
    return <div className={css({
      position: 'absolute',
      bottom: theme.sizing.scale600,
      right: theme.sizing.scale600,
      background: `${theme.colors.backgroundSecondary}99`,
      borderRadius: theme.borders.radius300,
      padding: theme.sizing.scale100,
      display: 'flex',
      gap: theme.sizing.scale200
    })}>
        {annotationsInFrame.map(([id]) => {
        const label = annotationIdToLabelMap.get(id);
        if (!label) {
          return null;
        }
        return <Diamond key={id} color={label.style.fillColor} stroke={label.style.strokeColor} />;
      })}
      </div>;
  };
  return <div className={css({
    width: '100%',
    height: '100%',
    overflowY: 'auto',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    backgroundColor: theme.colors.backgroundSecondary
  })}>
      {frameImageUrls.map((imageUrl, index) => <div onClick={() => handleFrameClick(index)} onKeyDown={event => {
      if (event.key === 'Enter') {
        handleFrameClick(index);
      }
    }} className={css({
      margin: theme.sizing.scale400,
      position: 'relative',
      border: index === currentFrame ? `${theme.sizing.scale100} solid ${theme.colors.borderAccent}` : `${theme.sizing.scale100} solid transparent`,
      borderRadius: theme.borders.radius300,
      cursor: 'pointer',
      transition: 'opacity,transform 100ms ease-out',
      ':hover': {
        opacity: 0.8,
        transform: `scale(1.05)`
      }
    })} key={`${imageUrl}-${index}`} ref={element => {
      if (element && currentFrame === index) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest'
        });
      }
    }} role="button" tabIndex={index}>
          <Badge content={index + 1} shape={SHAPE.rectangle} color={COLOR.primary}>
            <img src={imageUrl} className={css({
          width: '300px'
        })} alt={`${imageUrl}-${index}`} />
          </Badge>
          {getAnnotationsInFrame(index)}
        </div>)}
    </div>;
};